import {
  fileTypes,
  PROTOCOL_CONFIGS,
} from "/WebInterface/new-ui/assets/js/constants.js";
import { t } from "/WebInterface/new-ui/modules/localizations/localizations.js";

export const isExtensionIncluded = (customization, file) => {
  const splittedArr = customization?.value?.split(",");
  const extensions = splittedArr?.map((item) => item.trim());
  return extensions?.includes(utils.getFileExtension(file));
};

export const getImageURL = (item, frame = 1, size = 1) => {
  if (item.preview !== 0) {
    const currentAuth = utils.cookie.get("currentAuth");
    const imageURL = `<w-image src="/?command=getPreview&size=${size}&path=${utils.escapeHtmlAttr(
      item.href_path
    )}&frame=${frame}&c2f=${currentAuth}" class="icon-image" alt="${utils.escapeHtmlAttr(
      item.href_path
    )}" />`;
    return imageURL;
  }

  return "";
};

export const getFilePreviewGrid = (fileItem) => {
  const genericIconThumbnail = utils.getUserCustomizationValue(
    "genericIconThumbnail"
  );

  const imageURL = getImageURL(fileItem, 1, 3);
  if (imageURL && !genericIconThumbnail) {
    return imageURL;
  }

  if (fileItem.type === fileTypes.DIR) {
    return `<w-image src="/WebInterface/new-ui/assets/images/folder.png" alt="folder-img" class="media-image" />`;
  }

  const fileExtension = utils.isImageExtension(fileItem);
  const iconPath = fileExtension || "file";

  return `<w-image src="/WebInterface/new-ui/assets/images/file-extension-icons/${iconPath}-extension.png" alt="${iconPath}-img" class="media-image"/>`;
};

export const getAudioPreviewGrid = (fileItem, wave, autonext) => {
  if (fileItem.type === fileTypes.DIR) {
    return "";
  }
  if (utils.isAudioExtension(fileItem)) {
    return `<w-audio${wave ? "" : "-c"} src="${utils.escapeHtmlAttr(
      fileItem.href_path
    )}" dir="${autonext}" class="h-30px ${wave ? "w-100px" : "w-30px"}" data-margin-right="30px" />`;
  }
  return "";
};

export const getAudioPreviewList = (fileItem, wave, autonext) => {
  if (fileItem.type === fileTypes.DIR) {
    return "";
  }
  if (utils.isAudioExtension(fileItem)) {
    return `<w-audio${wave ? "" : "-c"} src="${utils.escapeHtmlAttr(
      fileItem.href_path
    )}" autonext="${autonext}" class="h-25px ${wave ? "w-100px" : "w-25px"}" data-margin-left="10px" />`;
  }
  return "";
};

export const getFilePreviewList = (fileItem) => {
  const imageURL = getImageURL(fileItem);

  const disableFolderExpansion = utils.getUserCustomizationValue(
    "disableFolderExpansionInTreeview"
  );
  const genericIconTree = utils.getUserCustomizationValue("genericIconTree");

  const canPreventExpand = fileItem.canPreventExpand || disableFolderExpansion;

  if (fileItem.type === fileTypes.DIR) {
    const expandIcon = fileItem.ariaExpanded ? "down" : "right";
    const folderIcon = fileItem.ariaExpanded ? "folder-open" : "folder-close";
    const expandHtml = !canPreventExpand
      ? `<i class="icon-chevron-${expandIcon} down-icon"></i>`
      : "";
    const imageHtml =
      imageURL || `<i class="icon-${folderIcon} folder-icon"></i>`;
    return `${expandHtml} ${imageHtml}`;
  }

  if (imageURL && !genericIconTree) return imageURL;

  const fileExtension =
    fileItem.type === fileTypes.FILE
      ? utils.isImageExtension(fileItem) || "file"
      : "file";

  return `<img src="/WebInterface/new-ui/assets/images/file-extension-icons/${fileExtension}-extension.png" class="icon-image" alt="${fileExtension}-img" onerror="this.onerror=null; this.src='/WebInterface/new-ui/assets/images/no-image-available.png';" />`;
};

export const getVFSIcon = (type, alternatePathToProtocolIcons) => {
  if (!type) return null;

  const normalizedType = type.toUpperCase();
  const config = PROTOCOL_CONFIGS[normalizedType];

  if (!config) {
    return `<img src="${
      alternatePathToProtocolIcons ||
      "/WebInterface/new-ui/assets/images/protocols"
    }/file.png" alt="file" width="25px" height="25px" />`;
  }

  const basePath =
    alternatePathToProtocolIcons ||
    "/WebInterface/new-ui/assets/images/protocols";
  return `<img src="${basePath}/${normalizedType.toLowerCase()}.png" alt="${
    config.alt
  }" width="25px" height="25px" />`;
};

export const ColumnsMapping = {
  "dashboard-size-sort-list": { class: "size-td", property: "size" },
  "dashboard-name-sort-list": { class: "name-td", property: "name" },
  "dashboard-root_dir-sort-list": { class: "path-td", property: "path" },
  "dashboard-created-sort-list": {
    class: "created-td",
    property: "created",
  },
  "dashboard-modified-sort-list": {
    class: "modified-td",
    property: "modified",
  },
  "dashboard-keywords-sort-list": {
    class: "keyword-td",
    property: "keywords",
  },
};

export const DownloadFileCardTemplateTexts = () => {
  return {
    cancelText: t("cancel"),
    removeText: t("remove"),
    pauseText: t("pause"),
    resumeText: t("resume"),
    waitingText: t("waiting"),
    pausingText: t("pausing"),
    elapsedText: t("elapsed"),
    remainingText: t("remaining"),
    speedText: t("speed"),
    cancelingText: t("canceling"),
    dependingOnMachineThisMayTakeApproxText: t(
      "dependingOnMachineThisMayTakeApprox"
    ),
    last10SecAverageSpeedText: t("last10SecAverageSpeed"),
    finalizingCopyingDataText: t(
      "finalizingCopyingDataFromTempFileToFinalCompleteFilePleaseWait"
    ),
    sandBoxDownloadMessageText: t("sandBoxDownloadMessage"),
  };
};

export const LoggedInInfoTexts = () => {
  return {
    customThemeText: t("customTheme"),
    logoutText: t("Logout"),
    informationText: t("information"),
    loginNameText: t("loginName"),
    loginTimeText: t("loginTime"),
    sessionTimeoutText: t("sessionTimeout"),
    browserNameText: t("browserName"),
    browserVersionText: t("browserVersion"),
    browserInfoText: t("browserInfo"),
    URLText: t("URL"),
    hostNameText: t("hostName"),
    versionText: t("version"),
    recentActionsText: t("recentActions"),
    socketUploadText: t("socketUpload"),
    socketDownloadText: t("socketDownload"),
    rangeText: t("range"),
  };
};

export const FilterSectionTexts = () => {
  return {
    filterText: t("filter"),
    clearText: t("clear"),
    sortText: t("sort"),
    nameText: t("name"),
    sizeText: t("size"),
    lastModifiedText: t("lastModified"),
    keywordsText: t("keywords"),
    keepDirectoriesOnTopText: t("keepDirectoriesOnTopWhileSorting"),
    smallGridText: t("smallGrid"),
    mediumGridText: t("mediumGrid"),
    largeGridText: t("largeGrid"),
    listText: t("list"),
    selectText: t("select"),
    toggle: t("toggle"),
    allItems: t("allItems"),
    none: t("none"),
    allFiles: t("allFiles"),
    allFolders: t("allFolders"),
    itemStartingWithDOT: t("itemStartingWithDOT"),
    modifiedToday: t("modifiedToday"),
    modifiedThisWeek: t("modifiedThisWeek"),
    modifiedThisMonth: t("modifiedThisMonth"),
    modifiedInLast60Days: t("modifiedInLast60Days"),
    modifiedInLast90Days: t("modifiedInLast90Days"),
    expandAllText: t("expandAll"),
    collapseAllText: t("collapseAll"),
    arrangeColumnsText: t("arrangeColumns"),
  };
};
